(() => {
  const selectors = '[data-bison-color-select], [data-bnl-live-color-select]';

  const centerSelected = (details) => {
    if (!details.open || !window.matchMedia('(max-width: 640px)').matches) return;
    const selected =
      details.querySelector('[data-bison-variant-choice][aria-pressed="true"]') ||
      details.querySelector('[data-bnl-live-choice][aria-pressed="true"]') ||
      details.querySelector('button:not([disabled])');
    if (!selected) return;
    requestAnimationFrame(() => {
      selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  };

  document.querySelectorAll(selectors).forEach((details) => {
    if (details.dataset.sharedColorPickerReady === 'true') return;
    details.dataset.sharedColorPickerReady = 'true';
    details.addEventListener('toggle', () => {
      if (details.open) {
        document.querySelectorAll(selectors).forEach((other) => {
          if (other !== details && other.open) other.open = false;
        });
      }
      centerSelected(details);
    });
  });


  let preview = document.querySelector('.bison-shared-color-preview');
  if (!preview) {
    preview = document.createElement('div');
    preview.className = 'bison-shared-color-preview';
    preview.setAttribute('aria-hidden', 'true');
    preview.innerHTML = '<img alt=""><span></span>';
    document.body.appendChild(preview);
  }

  const previewImage = preview.querySelector('img');
  const previewLabel = preview.querySelector('span');

  const hidePreview = () => {
    preview.classList.remove('is-visible');
    preview.setAttribute('aria-hidden', 'true');
  };

  const showPreview = (choice, details) => {
    if (!window.matchMedia('(min-width: 641px)').matches) return;
    const img = choice.querySelector('img');
    const label = choice.querySelector('span:last-child');
    if (!img) return;

    previewImage.src = img.currentSrc || img.src;
    previewLabel.textContent = (label?.textContent || '').replace(/\s*[—-]?\s*Sold out\s*$/i, '').trim();

    const menu = details.querySelector('.bison-color-select__menu, .bnl-live-color-select__menu');
    const rect = (menu || details).getBoundingClientRect();
    const gap = 14;
    const width = 220;
    const height = 250;

    let left = rect.right + gap;
    if (left + width > window.innerWidth - 12) {
      left = rect.left - width - gap;
    }
    left = Math.max(12, Math.min(left, window.innerWidth - width - 12));

    let top = rect.top;
    if (top + height > window.innerHeight - 12) {
      top = window.innerHeight - height - 12;
    }
    top = Math.max(12, top);

    preview.style.left = left + 'px';
    preview.style.top = top + 'px';
    preview.classList.add('is-visible');
    preview.setAttribute('aria-hidden', 'false');
  };

  document.querySelectorAll(selectors).forEach((details) => {
    const choices = details.querySelectorAll('[data-bison-variant-choice], [data-bnl-live-choice]');
    choices.forEach((choice) => {
      choice.addEventListener('mouseenter', () => showPreview(choice, details));
      choice.addEventListener('focus', () => showPreview(choice, details));
      choice.addEventListener('mouseleave', hidePreview);
      choice.addEventListener('blur', hidePreview);
      choice.addEventListener('click', hidePreview);
    });
    details.addEventListener('toggle', () => {
      if (!details.open) hidePreview();
    });
  });

  window.addEventListener('scroll', hidePreview, { passive: true });
  window.addEventListener('resize', hidePreview);
})();
